import {
  CLEAN_DETAIL_PURCHASE_ORDER_LIST_IPB,
  CLEAN_DETAIL_PURCHASE_ORDER_LIST_IPB_ERROR,
} from '_models/redux/types';

export const cleanDetailPurchaseOrderListIpbAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_PURCHASE_ORDER_LIST_IPB,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_PURCHASE_ORDER_LIST_IPB_ERROR,
    });
  }
};
